import { motion } from "framer-motion";
import { MaskedLines, Reveal } from "@/components/Reveal";
import { Topo, GridNetwork } from "@/components/Graphics";
import { Kicker, CTABand } from "@/components/Bits";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="relative overflow-hidden pt-40 pb-20">
        <motion.div
          initial={{ opacity: 0, rotate: -8 }}
          animate={{ opacity: 1, rotate: 0 }}
          transition={{ duration: 1.3, ease: [0.22, 1, 0.36, 1] }}
          className="pointer-events-none absolute -right-[16%] top-0 w-[64vw] max-w-[720px] text-primary/20"
        >
          <Topo className="w-full h-full" />
        </motion.div>
        <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
          <Kicker>About FaeVor Works</Kicker>
          <h1 className="font-display tracking-mega leading-[0.85] text-5xl sm:text-7xl lg:text-8xl mt-6 max-w-4xl">
            <MaskedLines lines={["There's a", "better way", "to move forward."]} />
          </h1>
        </div>
      </section>

      <section data-testid="meet-shalanda" className="mx-auto max-w-7xl px-5 sm:px-8 py-10">
        <div className="grid gap-12 lg:grid-cols-[5fr_7fr] lg:gap-20 items-center">
          <Reveal>
            <div className="relative">
              <div className="absolute -left-4 -top-4 h-full w-full rounded-3xl bg-primary/90" aria-hidden="true" />
              <div className="relative overflow-hidden rounded-3xl border border-border bg-secondary aspect-[4/5]">
                <img
                  src="https://customer-assets-eiarnc6j.emergentagent.net/job_opportunity-ahead/artifacts/w4ol302k_IMG_4528.jpeg"
                  alt="Shalanda Burgess, founder of FaeVor Works"
                  className="h-full w-full object-cover object-[center_20%] transition-transform duration-700 hover:scale-[1.03]"
                  data-testid="shalanda-photo"
                />
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-accent/45 via-transparent to-transparent" />
                <div className="absolute bottom-5 left-5 right-5 flex items-baseline justify-between text-primary-foreground">
                  <span className="font-display text-2xl tracking-tight">Shalanda Burgess</span>
                  <span className="text-[10px] uppercase tracking-[0.22em] opacity-80">Founder</span>
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <Kicker>Meet Shalanda</Kicker>
            <h2 className="font-display text-4xl sm:text-6xl tracking-mega leading-[0.92] mt-5 max-w-xl">
              Helping people find solutions & move forward.
            </h2>
            <div className="mt-8 space-y-5 text-lg text-foreground/75 leading-relaxed max-w-2xl">
              <p>
                Hi, I'm <span className="text-foreground font-semibold">Shalanda Burgess</span>, founder of
                FaeVor Works. I'm a real estate professional and entrepreneur with a genuine passion for
                helping people overcome challenges and discover solutions that move them forward.
              </p>
              <p>
                My experience has allowed me to work with individuals and families at different stages of
                life — from mobile homeowners looking for solutions to sell their homes to those simply
                exploring what their next move could look like.
              </p>
              <p>
                I believe that sometimes people don't need more pressure — they simply need the right
                information, the right resources, and someone willing to help them find a solution. That's why
                I created FaeVor Works.
              </p>
              <p>
                Through our <span className="text-foreground font-semibold">Real Estate Solutions</span>, I help
                mobile and manufactured homeowners explore their options — and connect them with practical
                next steps that make sense for their situation.
              </p>
              <p>
                My goal is simple: listen to your situation, understand your goals, and connect you with
                solutions that make sense for you. Your situation may have a solution. Your next opportunity may
                be closer than you think.
              </p>
            </div>
            <p className="mt-8 text-sm uppercase tracking-[0.22em] text-primary font-semibold">
              Don't Miss Out on Your FaeVor!
            </p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 sm:px-8 py-16">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl bg-accent text-accent-foreground p-10 sm:p-16">
            <div className="pointer-events-none absolute -right-10 -bottom-16 w-[45%] text-accent-foreground/10">
              <GridNetwork className="w-full h-full" />
            </div>
            <p className="relative font-display text-4xl sm:text-6xl tracking-mega leading-[0.95] max-w-3xl">
              There's FaeVor in Your Future.
            </p>
          </div>
        </Reveal>
      </section>

      <CTABand />
    </div>
  );
}
